import * as React from 'react';
import * as styles from './styles.css';
import { ArticleHeading2, LinkButton, ArticleParagraph1, useDeviceType } from '@cian/ui-kit';

import emoji from '../../static/emoji/img1.png';

interface IEmptyListingStubProps {
  changeTabsAction: React.ReactElement;
  url: string;

  onClick(): void;
}

export const EmptyListingStub: React.FC<IEmptyListingStubProps> = props => {
  const { changeTabsAction, url, onClick } = props;
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div className={styles['container']}>
      <img className={styles['emoji']} src={emoji} alt="emoji" />
      <div className={styles['title']}>
        <ArticleHeading2>Ничего не нашлось. Оставьте&nbsp;заявку и риелторы найдут вас сами</ArticleHeading2>
      </div>
      <div className={styles['subtitle']}>
        <ArticleParagraph1>
          Либо попробуйте изменить запрос, фильтры или переключитесь на {changeTabsAction}
        </ArticleParagraph1>
      </div>
      <div className={styles['action']}>
        <LinkButton href={url} size={isDesktop ? 'XS' : 'M'} onClick={onClick}>
          Оставить заявку риелтору
        </LinkButton>
      </div>
    </div>
  );
};

EmptyListingStub.displayName = 'EmptyListingStub';
